import { combineReducers } from 'redux'
import user from './user'
import runtime from './runtime'
import home from './home'
import search from './search'
import movieDetail from './movie-detail'
import recommendation from './recommendation'
import subscribe from './subscribe'
import { reducer as toastr } from 'react-redux-toastr'
import matches from './matches'
import feature from './feature'
import playlist from './playlist'
import headerMenu from './header-menu'
import configParams from './config-params'
import partnerRedeem from './partner-redeem'
import partners from './partners'
import notifications from './notifications'
import articles from './articles'
import sidebarMenu from './sidebar-menu'
import promo from './promo'
import refund from './refund'
import alertNotification from './alert'
import inbox from './inbox'
import standings from './standings'
import watchList from './reminders'
import snackbarFavorite from './snackbar-favorite'
import molaHub from './mola-hub'

export default combineReducers({
  user,
  runtime,
  home,
  search,
  movieDetail,
  toastr,
  recommendation,
  subscribe,
  matches,
  feature,
  playlist,
  headerMenu,
  configParams,
  partners,
  notifications,
  articles,
  partnerRedeem,
  sidebarMenu,
  promo,
  refund,
  alertNotification,
  inbox,
  standings,
  watchList,
  snackbarFavorite,
  molaHub,
})
